import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'periodDuration',
  standalone: true,
})
export class PeriodDurationPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(
    startDate: string | undefined | null,
    endDate: string | undefined | null,
  ): string {
    if (!startDate || !endDate) return '—';
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    if (Number.isNaN(start) || Number.isNaN(end) || end <= start) return '—';
    const days = Math.round((end - start) / (1000 * 60 * 60 * 24));
    if (days < 7) {
      return this.translate.instant('projectCard.durationDays', { count: days });
    }
    if (days < 60) {
      const weeks = Math.round((days / 7) * 10) / 10;
      return this.translate.instant('projectCard.durationWeeks', {
        count: weeks,
      });
    }
    if (days < 365) {
      const months = Math.round((days / (365.25 / 12)) * 10) / 10;
      return this.translate.instant('projectCard.durationMonths', {
        count: months,
      });
    }
    const years = Math.round((days / 365.25) * 10) / 10;
    return this.translate.instant('projectCard.durationYears', { count: years });
  }
}
